import switchEnviroment from 'easycommons/modules/Utils/switchEnviroment'

const getDeepLink = pathname => {
  const url = encodeURI(`${switchEnviroment('server')}/configuracoes${pathname}`)
  return `?redirect_url=${url}`
}

export default getDeepLink
